module.exports = __webpack_public_path__ + "static/img/85fifteen-323874-unsplash.6342519.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/85fifteen-323874-unsplash.jpg
// module id = rH+o
// module chunks = 1